import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Button,
  Menu,
  MenuItem
} from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../core/hooks/useStore";
import { headlinePigSlice } from "../../headline-pig";
import { keywordPigSlice } from "../../keyword-pig";

const ResultsMoreButton = (props: { niche: string }) => {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleGenerateKeywords = () => {
    navigate("/tools/keyword-tool");
    dispatch(keywordPigSlice.actions.setCreateDialogOpened(true));
    dispatch(keywordPigSlice.actions.setDefaultSearch(props.niche));
    handleClose();
  };

  const handleGenerateHeadlines = () => {
    navigate("/tools/headline-tool");
    dispatch(headlinePigSlice.actions.setCreateDialogOpened(true));
    dispatch(headlinePigSlice.actions.setDefaultSearch(props.niche));
    handleClose();
  };

  return (
    <>
      <Button
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<ArrowDropDownIcon />}
      >
        Generate
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={handleGenerateKeywords}>Keywords</MenuItem>
        <MenuItem onClick={handleGenerateHeadlines}>Headlines</MenuItem>
      </Menu>
    </>
  );
};

export default ResultsMoreButton;
